import { useEffect, useState } from "react"

import { useBooleanState } from "shared/lib/useBooleanState"
import { useEvent } from "shared/lib/useEvent"
import usePrevious from "shared/lib/usePrevious"
import { FeedbackType } from "shared/types/FeedbackType"

import { FeedbackButtonProps } from "../FeedbackButton"
import { FeedbackButtonViewModel } from "../ui/FeedbackButtonView"
import { useFeedbackActions } from "./useFeedbackActions"

export function useFeedbackButtonViewModel({
  onFeedbackTypeSelect,
  onClick,
  isDefaultOpen = false,
  ...rest
}: FeedbackButtonProps): FeedbackButtonViewModel {
  const [target, setTarget] = useState<HTMLElement | null>(null)

  const {
    value: isMenuVisible,
    setFalse: hideFeedbackMenu,
    setTrue: showFeedbackMenu,
    setValue: setMenuVisible
  } = useBooleanState(isDefaultOpen)

  const previousIsMenuVisible = usePrevious(isMenuVisible)
  useEffect(() => {
    if (previousIsMenuVisible && !isMenuVisible) {
      target?.focus()
    }
  }, [previousIsMenuVisible, isMenuVisible, target])

  const handleSelect = useEvent((feedbackType: FeedbackType) => {
    hideFeedbackMenu()
    onFeedbackTypeSelect(feedbackType)
  })

  const feedbackActions = useFeedbackActions(handleSelect)

  return {
    ...rest,
    feedbackActions,
    isMenuVisible,
    setTarget,
    onOpenChange: setMenuVisible,
    onClick: onClick || showFeedbackMenu
  }
}
